import script from "./HIFormInputSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./HIFormInputSignature.vue?vue&type=script&setup=true&lang=js"

import "./HIFormInputSignature.vue?vue&type=style&index=0&id=18a8f76e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a8f76e"]])

export default __exports__